import React, { Fragment, useEffect, useState } from "react";
import zapier from "../../assets/utils/images/Intagration image/zapier-icon.svg";
import requestApiService from "../../services/requestApi.service";
import { confirmBox, loadConnectedIntegration } from "../../Common/Appcommon";
import { cardData } from "./Constants";
import ShowIntegrationInfo from "./ShowIntDetails.js";

const Zapier = (props) => {
    let { install, installedButton, buttonValue, name } = props;
    const [isConnected, setConnectionStatus] = useState(false);
    const [carddata, setData] = useState(cardData);
    const [accountInfo, setAccountInfo] = useState([]);
    let key = '';
    let foundData = carddata.find((data) => data.name === "zapier");
    if (foundData) {
        key = foundData.component.button.key;
    }
    let integrationData = [];
    const [tabInfo, setTabInfo] = useState([]);
    useEffect(() => {
        (async () => {
            if(install === true){
                onInstallZapier();
            }
            await fetchGoogleAccountDetails();
        })();
        return () => {
            // this now gets called when the component unmounts
        };
    }, [install]);

    const fetchGoogleAccountDetails = async () => {
        let integrationInfo = await loadConnectedIntegration(name); //'gcalendar'
        if (integrationInfo.length > 0) {
            setConnectionStatus(true);
            let connectedInfo = integrationInfo[0][2];
            connectedInfo = JSON.parse(connectedInfo);
            let token = connectedInfo['token']['access_token'];
            let reftoken = connectedInfo['token']['refresh_token'];
            let IntegrationAccountInfo = [
                { type: "id", id: integrationInfo[0][0] },
                { type: "text", label: "Token", value: token },
                { type: "text", label: "Refresh Token", value: reftoken },
            ];
            setAccountInfo(IntegrationAccountInfo);
        } else {
            integrationData = [];
            setConnectionStatus(false);
            setTabInfo([]);
        }

    };


    const onInstallZapier = async (e) => { 
        window.open("https://zapier.com/apps/webhook/integrations", '_blank');
        /* let appHost = window.location.hostname;
        let protocol = window.location.protocol;
        let callback = protocol + "//" + appHost + "/#/oauth/callback";
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "GET_OAUTH_URL",
            NAME: "ZAPIER",
            CALLBACK: callback
        }
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            let authUrl = response.data;
            window.parent.location.href = authUrl;
        } */
    }

    const removeIntegration = async (e, integrationId) => {
        let confirm = await confirmBox("Are you sure want to Uninstall " + integrationHeadData.name + "?", "Uninstalling the " + integrationHeadData.name + " app all actions linked to it will stop working.", 'warning', 'Uninstall', 'Cancel');
        if (!confirm) {
            return;
        }
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "REMOVE_INTEGRATION",
            ID: integrationId
        }
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            // installedButton();
            // setintegrationId('');
            await fetchGoogleAccountDetails();
        }
    }

    /* const getSimpleTabs = () => {
        return tabInfo.map(({ name, biography }, index) => ({
            key: index,
            title: name,
            getContent: () => biography, // Render function if it's a component
        }));
    } */


    const integrationHeadData = {
        name: "Zapier",
        tag: "Automation",
        image: zapier,
        installButtonText: "Install App",
        uninstallButtonText: "Uninstall App",
    };

    const integrationContent = [
        { heading: "Website", subheading: "https://zapier.com", type: "url" },
        { heading: "Overview", subheading: "Connect your AI Voice Agent with Zapier to automate workflows across 5,000+ apps. Whether it's syncing lead data, triggering CRM actions, or updating calendars Zapier makes it easy to integrate your voice workflows without writing a single line of code.", type: "text" },
        { heading: "Key Benefits", 
            subheading: [
                { 
                    description: "Automate tasks between your AI agent and tools like CRMs, spreadsheets, calendars, and more." 
                },
                { 
                    description: "Trigger Zaps on events like new lead creation, updates, or call completions" 
                },
                { 
                    description: "Enable real-time data sync for faster follow-ups and streamlined workflows" 
                },
                { 
                    description: "No-code setup with thousands of pre-built app connections" 
                },
                { 
                    description: "Fully customizable based on your agency or client needs" 
                },], type: "list" },
        { heading: "How It Works", 
            subheading: [
                { 
                    title: "Create/Update Leads (via Webhooks)",
                    description: "Use Zapier to automatically create or update lead records, assign tags/lists, and update fields in your connected apps when voice calls are completed or events are triggered." 
                },
                { 
                    title: "Sync Data Across Tools (via Custom Actions)", 
                    description: "Pull lead information from CRMs, Google Sheets, or other systems to personalize AI calls. Once a call is complete, sync outcomes like responses, scores, or summaries back into those tools." 
                },
                { 
                    title: "Calendar Automation (via Custom Actions)", 
                    description: "Use Zapier to integrate with calendar tools like Calendly. Let the AI agent check availability, then book, cancel, or reschedule appointments directly through Zap-based workflows." 
                },
        ], type: "list" }
        
    ];


    return (
        <Fragment>
            <div className="agent-details">
                <ShowIntegrationInfo
                    keyname={name}
                    headData={integrationHeadData}
                    integrationData={integrationContent}
                    isInstalled={buttonValue.includes(name)}
                    isConnected={isConnected}
                    accountInfo={accountInfo}
                    onInstall={onInstallZapier}
                    onRemove={removeIntegration}
                />
            </div>
        </Fragment>
    );


}

export default Zapier;
